import React, { PropTypes } from 'react';
import classNames from 'classnames';

export const TYPE = {
  premium: 'btn-premium',
  default: 'btn-primary-new',
};

export const SIZE = {
  large: 'btn-large',
  small: 'btn-small',
  default: 'btn-medium',
};

const Button = ({
  onClick,
  children,
  className,
  type,
  size,
  ...props
}) => {
  const btnClass = classNames({
    btn: true,
    'btn-new': true,
    [type]: true,
    [size]: true,
    [className]: !!className,
  });

  return (
    <button className={btnClass} onClick={onClick} {...props}>
      {children}
    </button>
  );
};

Button.defaultProps = {
  type: TYPE.default,
  size: SIZE.default,
};

Button.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
};

export default Button;




// WEBPACK FOOTER //
// ./src/components/Button/Button.js